"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preview = void 0;

var React = require("react");

var utils_1 = require("./utils");

var EditorPropTypes_1 = require("./types/EditorPropTypes");

var config_1 = require("./config");

var Preview =
/** @class */
function (_super) {
  __extends(Preview, _super);

  function Preview(props) {
    var _this = _super.call(this, props) || this;

    _this.valueCursor = undefined;

    _this.initialise = function (attempts) {
      var _a, _b, _c;

      if (attempts === void 0) {
        attempts = 0;
      }

      var target = _this.elementRef.current;

      if (!target) {
        return; // Editor has been unmounted
      }

      if (!(0, utils_1.isInDoc)(target)) {
        // this is probably someone trying to help by rendering us offscreen
        // but we can't do that because the editor iframe must be in the document
        // in order to have state
        if (attempts === 0) {
          // we probably just need to wait for the current events to be processed
          setTimeout(function () {
            return _this.initialise(1);
          }, 1);
        } else if (attempts < 100) {
          // wait for ten seconds, polling every tenth of a second
          setTimeout(function () {
            return _this.initialise(attempts + 1);
          }, 100);
        } else {
          // give up, at this point it seems that more polling is unlikely to help
          throw new Error('editor can only be initialised when in a document');
        }

        return;
      }

      var editorInstance = (0, utils_1.getEditorInstance)();

      if (!editorInstance) {
        throw new Error('editor should have been loaded into global scope');
      }

      var CURRENT_ENV_VAR = (_a = _this.props.env) !== null && _a !== void 0 ? _a : 'staging';
      var DEFAULT_CONTENT_CSS = ['tekie', (0, utils_1.withURLPrefix)(CURRENT_ENV_VAR, _this.props.urlPrefix, config_1.config[(_b = _this.props.env) !== null && _b !== void 0 ? _b : 'staging'].customStyleSrc)];
      var DEFAULT_FONT_CSS = ['tekie', (0, utils_1.withURLPrefix)(CURRENT_ENV_VAR, _this.props.urlPrefix, config_1.config[(_c = _this.props.env) !== null && _c !== void 0 ? _c : 'staging'].fontStyleSrc)];

      var INITIAL_CONFIG = __assign(__assign({}, _this.props.init), {
        plugins: (0, utils_1.mergePlugins)('autolink directionality code image link media template codesample table hr pagebreak nonbreaking anchor toc advlist lists wordcount imagetools textpattern noneditable charmap emoticons autoresize', undefined),
        selector: undefined,
        target: target,
        noneditable_noneditable_class: 'mceNonEditable',
        content_style: 'body { font-family:Nunito,Arial,sans-serif; font-size:16px }',
        image_caption: true,
        readonly: true,
        branding: false,
        skin: 'tekie',
        content_css: DEFAULT_CONTENT_CSS,
        font_css: DEFAULT_FONT_CSS,
        toolbar: false,
        statusbar: false,
        menubar: false,
        setup: function setup(editor) {
          _this.editor = editor;
          editor.on('init', function () {
            Array.from(editor.getDoc().querySelectorAll('.mce-object-iframe')).map(function (el) {
              el.addEventListener('click', function () {
                el.setAttribute('data-mce-selected', '2');
              });
            });
          });

          if (!(0, utils_1.isTextareaOrInput)(target)) {
            editor.once('PostRender', function (_evt) {
              editor.setContent(_this.getInitialValue(), {
                no_events: true
              });
            });
          }

          if (_this.props.init && (0, utils_1.isFunction)(_this.props.init.setup)) {
            _this.props.init.setup(editor);
          }
        },
        init_instance_callback: function init_instance_callback(editor) {
          var _a; // check for changes that happened since editorInstance.init() was called


          var initialValue = _this.getInitialValue();

          _this.currentContent = (_a = _this.currentContent) !== null && _a !== void 0 ? _a : editor.getContent();

          if (_this.currentContent !== initialValue) {
            _this.currentContent = initialValue;
            editor.setContent(initialValue);
            editor.undoManager.clear();
            editor.undoManager.add();
            editor.setDirty(false);
          }

          ;
          editor.setMode('readonly'); // ensure existing init_instance_callback is called

          if (_this.props.init && (0, utils_1.isFunction)(_this.props.init.init_instance_callback)) {
            _this.props.init.init_instance_callback(editor);
          }
        }
      });

      if ((0, utils_1.isTextareaOrInput)(target)) {
        target.value = _this.getInitialValue();
      }

      editorInstance.init(INITIAL_CONFIG);
    };

    _this.id = _this.props.id || (0, utils_1.generateUUID)('tekie-ce-readOnly');
    _this.elementRef = React.createRef();
    _this.boundHandlers = {};
    return _this;
  }

  Preview.prototype.componentDidUpdate = function () {
    var _this = this;

    var _a;

    if (this.editor) {
      if (this.editor.initialized) {
        this.currentContent = (_a = this.currentContent) !== null && _a !== void 0 ? _a : this.editor.getContent();

        if (typeof this.props.value === 'string' && this.props.value !== this.currentContent) {
          var localEditor_1 = this.editor;
          localEditor_1.undoManager.transact(function () {
            // inline editors grab focus when restoring selection
            // so we don't try to keep their selection unless they are currently focused
            var cursor;

            if (localEditor_1.hasFocus()) {
              try {
                // getBookmark throws exceptions when the editor has not been focused
                // possibly only in inline mode but I'm not taking chances
                cursor = localEditor_1.selection.getBookmark(3);
              } catch (e) {
                /* ignore */
              }
            }

            var valueCursor = _this.valueCursor;
            localEditor_1.setContent(_this.props.value);

            if (localEditor_1.hasFocus()) {
              for (var _i = 0, _a = [cursor, valueCursor]; _i < _a.length; _i++) {
                var bookmark = _a[_i];

                if (bookmark) {
                  try {
                    localEditor_1.selection.moveToBookmark(bookmark);
                    _this.valueCursor = bookmark;
                    break;
                  } catch (e) {
                    /* ignore */
                  }
                }
              }
            }
          });
        }
      }
    }
  };

  Preview.prototype.componentDidMount = function () {
    var _a, _b, _c, _d, _e, _f;

    if ((0, utils_1.getEditorInstance)() !== null) {
      this.initialise();
    } else if (this.elementRef.current && this.elementRef.current.ownerDocument) {
      utils_1.ScriptLoader.load(this.elementRef.current.ownerDocument, this.getScriptSrc(), (_b = (_a = this.props.scriptLoading) === null || _a === void 0 ? void 0 : _a.async) !== null && _b !== void 0 ? _b : false, (_d = (_c = this.props.scriptLoading) === null || _c === void 0 ? void 0 : _c.defer) !== null && _d !== void 0 ? _d : false, (_f = (_e = this.props.scriptLoading) === null || _e === void 0 ? void 0 : _e.delay) !== null && _f !== void 0 ? _f : 0, this.initialise);
    }
  };

  Preview.prototype.componentWillUnmount = function () {
    var _this = this;

    var editor = this.editor;

    if (editor) {
      Object.keys(this.boundHandlers).forEach(function (eventName) {
        editor.off(eventName, _this.boundHandlers[eventName]);
      });
      this.boundHandlers = {};
      editor.remove();
      this.editor = undefined;
    }
  };

  Preview.prototype.render = function () {
    return React.createElement('textarea', {
      ref: this.elementRef,
      style: {
        visibility: 'hidden'
      },
      name: this.props.textareaName,
      id: this.id
    });
  };

  Preview.prototype.getScriptSrc = function () {
    var _a;

    if (typeof this.props.customScriptSrc === 'string') {
      return this.props.customScriptSrc;
    } else {
      var CURRENT_ENV = (_a = this.props.env) !== null && _a !== void 0 ? _a : 'staging';
      return (0, utils_1.withURLPrefix)(CURRENT_ENV, this.props.urlPrefix, config_1.config[CURRENT_ENV].scriptSrc);
    }
  };

  Preview.prototype.getInitialValue = function () {
    if (typeof this.props.value === 'string') {
      return this.props.value;
    } else {
      return '';
    }
  };

  Preview.propTypes = EditorPropTypes_1.EditorPropTypes;
  Preview.defaultProps = {
    env: 'staging'
  };
  return Preview;
}(React.Component);

exports.Preview = Preview;